import React, {useEffect} from 'react';
import LocationContact from "btdt/react/LocationContact";

export default function OnlineOrderStep({animating, chosenLocation, useBinTracker, handleBinTrackerChange, handleNextStep}) {

    useEffect(() => {
        handleBinTrackerChange(null);
    }, []);

    return (
        <div className={"container mx-auto px-4 lg:px-8"}>
            <div className={"grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-6"}>
                <div className={"lg:col-span-8 lg:col-start-3"}>
                    <div className={"large-p mb-6"}>
                        This location offers online payments. Would you like to order and pay online?
                    </div>
                    <p>
                        <strong>If yes</strong>, you will be taken to our online ordering form. <strong>If not</strong>, your request will be sent to our location and confirmed before your booking is complete.
                    </p>
                </div>
                <div className={"lg:col-span-8 grid grid-cols-subgrid gap-x-8 gap-y-5 lg:col-start-3"}>

                    <div className={"lg:col-span-4 radio-option"}>
                        <input type="radio" name={'online'} id={`online-yes`} value={'yes'} className={"peer"} onChange={() => handleBinTrackerChange(true)}/>
                        <label htmlFor={`online-yes`} className={"check peer-checked:bg-brand-green-light"}>
                            Yes
                        </label>
                    </div>

                    <div className={"lg:col-span-4 radio-option"}>
                        <input type="radio" name={'online'} id={`online-no`} value={'no'} className={"peer"} onChange={() => handleBinTrackerChange(false)}/>
                        <label htmlFor={`online-no`} className={"check peer-checked:bg-brand-green-light"}>
                            No
                        </label>
                    </div>

                    <div className={"lg:col-span-8"}>
                        <button className={"btn"} disabled={animating || useBinTracker === null} onClick={handleNextStep}>
                            Next Step →
                        </button>
                    </div>
                </div>
                <div className={"lg:col-span-8 lg:col-start-3"}>
                    <LocationContact location={chosenLocation}/>
                </div>
            </div>
        </div>
    )
}